/* ============================================================
   ECADRA — Collection JS (المرحلة 2)
   فلترة + ترتيب + pagination بالـ Section Rendering API — من غير refresh
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-collection-root]');
  if (!root) return;

  var sectionId = root.dataset.sectionId;
  var collectionUrl = root.dataset.collectionUrl || window.location.pathname;
  var fetching = false;

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- بناء الـ URL من حالة الفلاتر + الترتيب ---------- */
  function buildParams() {
    var params = new URLSearchParams();
    var form = qs('[data-filters-form]', root);
    if (form) {
      var fd = new FormData(form);
      fd.forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
    }
    var sort = qs('[data-sort]', root);
    if (sort && sort.value) params.set('sort_by', sort.value);
    return params;
  }

  /* ---------- جلب السيكشن وتبديل الأجزاء ---------- */
  function renderFromUrl(url, push) {
    if (fetching) return;
    fetching = true;
    root.classList.add('is-loading');

    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    fetch(fetchUrl.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        ['[data-product-grid]', '[data-active-chips]', '[data-product-count]', '[data-pagination]', '[data-filters-body]'].forEach(function (sel) {
          var fresh = qs(sel, tmp);
          var current = qs(sel, root);
          if (current) {
            if (fresh) { current.replaceWith(fresh); }
            else if (sel === '[data-pagination]') { current.remove(); }
          } else if (fresh && sel === '[data-pagination]') {
            var grid = qs('[data-product-grid]', root);
            if (grid) grid.after(fresh);
          }
        });
        updateFilterCount();
        if (push) {
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          history.pushState({}, '', clean.toString());
        }
      })
      .catch(function () { window.location.href = url; })
      .finally(function () {
        fetching = false;
        root.classList.remove('is-loading');
      });
  }

  function applyFilters() {
    var params = buildParams();
    var url = collectionUrl + (params.toString() ? '?' + params.toString() : '');
    renderFromUrl(url, true);
  }

  function updateFilterCount() {
    var badge = qs('[data-active-count]', root);
    if (!badge) return;
    var n = qsa('[data-chip]', root).length;
    badge.hidden = n === 0;
    badge.textContent = n;
  }
  updateFilterCount();

  /* ---------- الأحداث (delegation عشان العناصر بتتبدل) ---------- */
  var debounce;
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-filters-form]')) {
      clearTimeout(debounce);
      debounce = setTimeout(applyFilters, e.target.type === 'number' ? 600 : 120);
      return;
    }
    if (e.target.matches('[data-sort]')) applyFilters();
  });

  document.addEventListener('click', function (e) {
    /* شيبس الإزالة */
    var chip = e.target.closest('[data-chip]');
    if (chip) { e.preventDefault(); renderFromUrl(chip.getAttribute('href'), true); return; }

    /* مسح الكل */
    var clear = e.target.closest('[data-filters-clear]');
    if (clear) { e.preventDefault(); renderFromUrl(collectionUrl, true); return; }

    /* الـ pagination */
    var pageLink = e.target.closest('[data-pagination] a');
    if (pageLink) {
      e.preventDefault();
      renderFromUrl(pageLink.getAttribute('href'), true);
      var head = qs('.e-collection__toolbar', root);
      if (head) head.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* زرار back/forward في المتصفح */
  window.addEventListener('popstate', function () {
    renderFromUrl(window.location.href, false);
  });
})();